import styled, { css } from 'styled-components';

export const Content = styled.input`
  width: 15px;
  height: 15px;
  background-color: #fff;
  color: #000;
  /* border: 1px solid #767676; */
  ${(props) =>
    props.theme.theme === 'dark' &&
    css`
      background-color: #4f5761;
      color: #fff;
    `}
`;
